import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { COAST_VOICE_PHONE } from '../../../../env';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { ConfirmCheck } from '../../../../theme/coast/icons';

const completePageSelector = ({ preliminaryInfo, portal }: RootState) => ({
  email: preliminaryInfo.info.email,
  embedded: portal.isEmbedded,
});

const ApplicationCompletePage: FC = () => {
  const { email, embedded } = useSelector(completePageSelector);

  const approvalMessage = embedded ? (
    <>
      Please come back in some time to access your Coast account. <br />
      We will send an email to&nbsp;
      <Typography color="primary" variant="body2" component="span">
        {email}
      </Typography>{' '}
      when it&apos;s ready.
    </>
  ) : (
    <>
      We&apos;ve sent an email to&nbsp;
      <Typography color="primary" variant="body2" component="span">
        {email}
      </Typography>{' '}
      with instructions <br /> on how to sign in to the customer portal.
    </>
  );

  const callUs = (
    <Typography variant="body2" align="center" color="textSecondary">
      If you don&apos;t receive it within a few minutes, please call us at:
      <Typography variant="body2" component="span" color="primary">
        {COAST_VOICE_PHONE}
      </Typography>
    </Typography>
  );

  return (
    <TerminalWizardPage icon={<ConfirmCheck />} title="You're Approved!" subtext={approvalMessage}>
      {callUs}
    </TerminalWizardPage>
  );
};

export { ApplicationCompletePage };
